import { render, staticRenderFns } from "./SpotSpecification.vue?vue&type=template&id=c438d2a6&"
import script from "./SpotSpecification.vue?vue&type=script&lang=js&"
export * from "./SpotSpecification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports